import React from 'react';
import { Box, CircularProgress, Typography, Fade } from '@mui/material';

function LoadingSpinner({ 
  size = 40, 
  message = 'Loading...', 
  fullScreen = false,
  color = 'primary'
}) {
  const content = (
    <Fade in timeout={300}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          ...(fullScreen && {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            zIndex: 9999,
          }),
        }}
      >
        <CircularProgress size={size} color={color} />
        {message && (
          <Typography variant="body2" color="text.secondary">
            {message}
          </Typography>
        )}
      </Box>
    </Fade>
  );

  if (fullScreen) {
    return content;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 200,
        py: 4,
      }}
    >
      {content}
    </Box>
  );
}

export default LoadingSpinner;